import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../AuthContext";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  async function onSubmit(e) {
    e.preventDefault();
    setErr(""); setBusy(true);
    try {
      await login(email, password);
      nav("/dashboard");
    } catch (ex) {
      setErr(ex?.response?.data?.detail || "Login failed");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center"
         style={{ background: "linear-gradient(145deg,#0d1f3c 0%,#1a3666 55%,#00676f 100%)" }}
         data-testid="login-page">
      <div className="bg-white rounded-3xl p-11 w-[400px] shadow-2xl">
        <div className="text-center mb-8">
          <div className="w-14 h-14 rounded-2xl mx-auto mb-3 flex items-center justify-center text-3xl font-black"
               style={{ background: "#1a3666", color: "#00a3a3", letterSpacing: "-2px" }}>v</div>
          <h1 className="text-xl font-bold" style={{ color: "#1a3666" }}>valantic vSDI</h1>
          <p className="text-xs text-slate-500 mt-1">Billability &amp; Utilization Dashboard</p>
        </div>

        <form onSubmit={onSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium mb-1.5">Email</label>
            <input data-testid="login-email" type="email" required value={email}
                   onChange={(e) => setEmail(e.target.value)}
                   className="w-full px-3.5 py-2.5 border-[1.5px] border-slate-200 rounded-lg text-sm outline-none focus:border-teal-600"
                   placeholder="you@sdi.valantic.com" />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1.5">Password</label>
            <input data-testid="login-password" type="password" required value={password}
                   onChange={(e) => setPassword(e.target.value)}
                   className="w-full px-3.5 py-2.5 border-[1.5px] border-slate-200 rounded-lg text-sm outline-none focus:border-teal-600" />
          </div>
          <button type="submit" disabled={busy} data-testid="login-submit"
                  className="w-full py-3 text-white rounded-lg text-sm font-semibold disabled:opacity-60"
                  style={{ background: "#1a3666" }}>
            {busy ? "Signing in…" : "Sign In →"}
          </button>
          {err && <div className="text-red-600 text-sm text-center" data-testid="login-error">{err}</div>}
        </form>
      </div>
    </div>
  );
}
